import { apiClient } from "./client";
import type { QbStatus } from "../types/dashboard";

/**
 * Requests the QuickBooks OAuth2 authorization URL from the backend.
 * Redirect the user to this URL to initiate the QB connection flow.
 */
export async function getQbAuthUrl(): Promise<string> {
  const response = await apiClient.get<{ url: string }>(
    "/api/auth/quickbooks/authorize"
  );
  return response.data.url;
}

/**
 * Returns the current QuickBooks connection status for the configured realm.
 */
export async function getQbStatus(): Promise<QbStatus> {
  const response = await apiClient.get<QbStatus>("/api/auth/quickbooks/status");
  return response.data;
}
